import { Box } from '@mantine/core';

import { useGetColor } from 'hooks';

import type { IconPropsType } from './types';

export const SignatureSmsOutlineIcon = ({
  color,
  size = 24,
  sx,
  ...props
}: IconPropsType) => {
  const iconColor = useGetColor(color);

  return (
    <Box
      component="svg"
      sx={sx}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.2857 16.5714H13.7143M7.42856 20H16.5714C17.2026 20 17.7143 19.4883 17.7143 18.8571V5.14286C17.7143 4.51167 17.2026 4 16.5714 4H7.42856C6.79738 4 6.28571 4.51168 6.28571 5.14286V18.8571C6.28571 19.4883 6.79738 20 7.42856 20Z"
        stroke={iconColor}
        strokeWidth="1.5"
      />
    </Box>
  );
};
